import { LegalLayout } from '../../components/LegalLayout';
import { t } from '../../hooks/useT';
import { LegalBody } from './LegalBodies';

export function CGVPage() {
  return (
    <LegalLayout title={t('legal.cgv.title')} lead={t('legal.cgv.lead')}>
      <LegalBody page="cgv" />
    </LegalLayout>
  );
}
